import _JSXStyle from "styled-jsx/style";
import React from 'react';
import PropTypes from 'prop-types';
import Color from 'color';
import { COLORS, OPACITIES } from '../constants.js';
import { fullCalendarToIcsUrl, fullCalendarToGoogleUrl } from '../utils.js';
var buttonHoverBackgroundColor = new Color(COLORS.ACCENT).alpha(OPACITIES.SECONDARY);

var AddToCalendar = function AddToCalendar(_ref) {
  var event = _ref.event;
  return /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["3180946338", [COLORS.ACCENT, COLORS.ACCENT, buttonHoverBackgroundColor]]]) + " " + "add-to-calendar"
  }, "Add event to calendar", /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["3180946338", [COLORS.ACCENT, COLORS.ACCENT, buttonHoverBackgroundColor]]]) + " " + "buttons-container"
  }, /*#__PURE__*/React.createElement("a", {
    href: fullCalendarToGoogleUrl(event),
    target: "_blank",
    rel: "noopener noreferrer",
    className: _JSXStyle.dynamic([["3180946338", [COLORS.ACCENT, COLORS.ACCENT, buttonHoverBackgroundColor]]])
  }, "Google Calendar"), /*#__PURE__*/React.createElement("a", {
    href: fullCalendarToIcsUrl(event),
    className: _JSXStyle.dynamic([["3180946338", [COLORS.ACCENT, COLORS.ACCENT, buttonHoverBackgroundColor]]])
  }, "Outlook / Other")), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3180946338",
    dynamic: [COLORS.ACCENT, COLORS.ACCENT, buttonHoverBackgroundColor]
  }, [".add-to-calendar.__jsx-style-dynamic-selector{-webkit-box-flex:1;-webkit-flex-grow:1;-ms-flex-positive:1;flex-grow:1;font-size:0.75em;}", ".buttons-container.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:space-around;-webkit-justify-content:space-around;-ms-flex-pack:space-around;justify-content:space-around;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;}", "a.__jsx-style-dynamic-selector{-webkit-text-decoration:none;text-decoration:none;border-radius:4px;padding:0.25em 0.5em;margin:0.25em;border:2px solid ".concat(COLORS.ACCENT, ";color:").concat(COLORS.ACCENT, ";}"), "a.__jsx-style-dynamic-selector:hover{color:white;background-color:".concat(buttonHoverBackgroundColor, ";}")]));
};

AddToCalendar.propTypes = {
  event: PropTypes.shape({
    start: PropTypes.object,
    end: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    location: PropTypes.string,
    url: PropTypes.string
  })
};
export default AddToCalendar;